import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifInput from '@ey/motif-react-wrapper/Input';
import MotifToggleSwitch from '@ey/motif-react-wrapper/ToggleSwitch';
import MotifButton from '@ey/motif-react-wrapper/Button';
import { labels } from '../../../../util/uiconstants';
import { getRegion } from '../../../../actions/admin/masterDataActions';
import { editTemplate } from '../../../../actions/admin/templatemanagementaction';
import { clearErrors } from '../../../../actions/erroractions';
import { setIsModalOpen } from '../../../../actions/modalstateactions';
import Loader from '../../../Common/Loaders/loadingindicator';
import env from '../../../../util/env';
import Toast from '../../../Common/Toast/Toast';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import { getLocalizedAPIError, validateTicketNumber } from '../../common/util';
import TicketField from '../../common/ticketfield';

function TemplateDetails(props) {
	// hooks
	var editTemplateData = props.editTemplateData;
	const [templateName, setTemplateName] = useState(
		editTemplateData?.templateName
	);
	const [status, setStatus] = useState(editTemplateData?.isPublished);
	const [selectedRegionIds, setRegionIds] = useState(
		editTemplateData?.regions?.map((x) => x.regionId.toString())
	);
	const [isAssignButonDisable, setIsAssignButonDisable] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const regions = useSelector((store) => store.regions);
	const [errorMessage, setErrorMessage] = useState(false);
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		clearError(true);
		if (Object.keys(regions).length === 0) {
			getRegions();
		}
	}, []);

	useEffect(() => {
		if (
			templateName == editTemplateData?.templateName &&
			selectedRegionIds.every((r) =>
				editTemplateData?.regions?.some((er) => er.regionId == r)
			) &&
			editTemplateData.regions.length == selectedRegionIds.length &&
			status == editTemplateData?.isPublished ||
			ticketNumber.trim().length <= 0
		) {
			setIsAssignButonDisable(true);
		} else if (
			templateName?.trim() &&
			selectedRegionIds &&
			selectedRegionIds?.length > 0
		) {
			setIsAssignButonDisable(false);
		} else {
			setIsAssignButonDisable(true);
		}
	}, [templateName, selectedRegionIds, status, ticketNumber]);

	const onTicketChanged = (e) => {
		setTicketNumber(e.target.value);
	}

	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	const handlerOnEditTemplateName = (e) => {
		setTemplateName(e.target.value);
	};

	const saveTemplate = () => {
		setIsSubmitClicked(true);
		if (!validateTicketNumber(ticketNumber)) {
			return;
		}

		setIsLoading(true);
		const regionIds = selectedRegionIds?.map((regionId) => {
			return Number(regionId);
		});

		var templateDetails = {
			templateName: templateName,
			isTemplatePusblished: status,
			areaRegionList: regionIds ? regionIds : [],
			ticketNumber: ticketNumber
		};

		let editTemplateUrl =
			env.getURL('serviceUrlV2') +
			`admin/engagementtemplates/${editTemplateData.copyRequestId}`;
		dispatch(editTemplate(editTemplateUrl, templateDetails))
			.then(() => {
				props.setIsTemplateEdited(true);
				props.closeEditTemplateModal();
				props.setEditTemplateSuccessMessage(labels.templateEditSuccessMessage);
			})
			.catch((result) => {
				var localError = getLocalizedAPIError(result);
				setErrorMessage(localError);
			})
			.finally(() => {
				setIsLoading(false);
				setIsSubmitClicked(false);
			});
	};

	const formatOptionLabel = ({ value, label }) => (
		<EllipsesControl content={label} tooltip={label} noOfLines={1} />
	);

	const dropDownOnChange = (option) => {
		setRegionIds(option);
	};

	const getRegions = () => {
		setIsLoading(true);
		let getRegionUrl = env.getURL('serviceUrlV2') + 'Regions';
		dispatch(getRegion(getRegionUrl))
			.then(() => { })
			.catch((e) => {
				setErrorMessage(e.toString());
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const getRegionsForDropDown = () => {
		let regionCollection = [];
		if (Object.keys(regions).length > 0) {
			_.forEach(regions, (item) => {
				regionCollection.push({
					label: item.regionName,
					value: item.regionID.toString()
				});
			});
		}
		return regionCollection;
	};

	const createDropDown = (collection) => {
		return (
			<MotifFormField>
				<MotifLabel id="select-label-search" position='in'>
					{labels.templateAreaRegion}
				</MotifLabel>
				<MotifSelect
					id={'region'}
					labelposition='in'
					onChange={(e) => dropDownOnChange(e)}
					filter
					arialabelledby="select-label-search"
					multiple={true}
					showselectallbutton={true}
					value={selectedRegionIds?.length ? selectedRegionIds : null}
				>
					{collection?.map((item) => (
						<MotifOption
							key={item.value}
							value={item.value}
							label={item.label}
						>
							<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
						</MotifOption>
					))}
				</MotifSelect>
			</MotifFormField>
		);
	};

	const hideEditTemplateDrawer = () => {
		setTemplateName(null);
		setRegionIds(null);
		setErrorMessage(false);
		props.closeEditTemplateModal();
	};

	return (
		<Mainwrapper>
			{isLoading ? (
				<Loader show view="blockView" styleName="loadingstyle" />
			) : (
				<section>
					<section
						className="toastMessage"
						style={{ display: errorMessage ? 'block' : 'none' }}
					>
						<Toast
							variant="error"
							onClose={() => {
								setErrorMessage(false);
							}}
						>
							{errorMessage}
						</Toast>
					</section>
					<section className="edittemplate">
						<MotifFormField>
							<MotifLabel position='in'>{labels.templateName}</MotifLabel>
							<MotifInput
								value={templateName}
								labelposition='in'
								maxLength={500}
								clearButtonTitle={labels.clear}
								onChange={handlerOnEditTemplateName}
							/>
						</MotifFormField>
						{createDropDown(getRegionsForDropDown())}
						<section className="status">
							<section className="showinactive">
								<MotifToggleSwitch
									aria-describedby="showstatus"
									checked={status}
									onChange={(event) => {
										setStatus(event.target.checked);
									}}
									id="toggle1"
									onLabel={labels.templatePublished}
									offLabel={labels.templateUnpublished}
								/>
							</section>
						</section>
						<TicketField
							ticketNumber={ticketNumber}
							onTicketChanged={onTicketChanged}
							showValidation={isSubmitClicked}
						/>
					</section>
				</section>
			)}
			<section className="modal-footer">
				<MotifButton
					variant="ghost"
					size='medium'
					onClick={() => hideEditTemplateDrawer()}
					disabled={isLoading}
				>
					{labels.templateEditCancel}
				</MotifButton>
				<MotifButton
					variant="primary"
					size='medium'
					onClick={() => saveTemplate()}
					disabled={isAssignButonDisable || isLoading}
				>
					{labels.templateEditSave}
				</MotifButton>
			</section>
		</Mainwrapper>
	);
}

const Mainwrapper = styled.section`

	.edittemplate {
		padding: var(--spacing-x-large);
		height: calc(100vh - var(--px-194));
		.motif-form-field {
			width: 90%;
			padding-bottom: var(--spacing-x-large);
		}
		.ticketdetail{
			.description {
				padding-bottom: var(--spacing-small);
			}
			.motif-form-field{
				width: var(--px-400);
				padding-bottom: 0;
			}
		}
		.status {
			padding-bottom: var(--spacing-x-large)
		}
	}

	.modal-footer {
		display: inline-flex;
		width: 100%;
		padding: var(--spacing-x-large);
		justify-content: end;
		button {
			margin-left: var(--px-12);
		}
	}

	.loadingstyle {
		position: absolute;
		top: 50%;
		left: 50%;
	}

	.toastMessage {
		padding: var(--spacing-x-large) var(--spacing-x-large) 0;
	}

	//heading
	.templatemanagement {
		.pageheading {
			display: flex;
			padding: var(--px-20) 0;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
			}
		}
	}

	.errorRow {
		color: var(--red-600) !important;
	}
`;

export default TemplateDetails;
